import React, { Component } from "react";
import PropTypes from "prop-types";
import Banner from "../../../img/banner.jpg";
import * as Theme from "../../../app/Theme";
import * as GBConst from "../../GB/GBConst";

class HLIntroBanner extends Component {
    static propTypes = {
        left: PropTypes.number,
        sideBarOpen: PropTypes.bool,
        screenSize: PropTypes.number,
    };

    static defaultProps = {
        left: 0,
        sideBarOpen: false,
        screenSize: GBConst.lgScreen,
    };

    render() {
        const props = this.props;
        const left = props.left;

        /* whiteSpace : "nowrap" prevents Welcome text from running into tool description when
           the side bar is open and you shrink the screen. */

        /* height of the img must be specified or you will physically see the image being drawn on the screen,
           which is not pretty. The aspect ratio (height / width) is about 0.40, and the left takes the sidebar
           into account. Starting background as white helps eliminate some jitteriness too. */
        let bannerImg = (
            <img
                style={{
                    width: "calc(100% - 1px)",
                    height: (window.innerWidth - left) * 0.4,
                    background: Theme.whiteColor,
                    // top: 108,
                    left: 0,
                }}
                src={Banner}
                alt=""
            />
        );

        let welcomeTextStyle = {
            ...Theme.appTitleFontStyle,
            color: Theme.whiteColor,
            fontWeight: "bold",
            fontSize: this.props.sideBarOpen
                ? 22
                : window.innerWidth >= GBConst.mdScreen
                ? 26
                : window.innerWidth >= GBConst.smScreen
                ? 22
                : 14,
            lineHeight: 1.5,
            left: window.innerWidth >= GBConst.mdScreen ? 70 : 40, //(window.innerWidth >= HLConst.HL_MdScreen ? ((this.props.sideBarOpen) ? 340 : 70) : 40),//210,
            top: window.innerWidth >= GBConst.mdScreen ? 35 : window.innerWidth >= GBConst.smScreen ? 28 : 15,
            marginBottom: 90,
            position: "absolute",
            textAlign: "left",
            userSelect: "none", // don't let user highlight text
            width: window.innerWidth >= GBConst.mdScreen ? 705 : window.innerWidth >= GBConst.smScreen ? 395 : 250,
            backgroundColor: "rgba(9, 44, 116, .38)",
            borderRadius: 25,
            padding: 22,
        };

        const welcomeText = (
            <div style={welcomeTextStyle}>
                H-LiST provides evidence-based recommendations on which maternal and child health, nutrition and water,
                sanitation and hygiene (WASH) interventions, at specified coverage levels, can save the most lives.
            </div>
        );

        let sourceTextStyle = {
            ...Theme.appTitleFontStyle,
            color: Theme.whiteColor,
            fontSize: this.props.sideBarOpen ? 18 : 22,
            lineHeight: 1.5,
            left: 70,
            // left: (this.props.sideBarOpen) ? 340 : 70,//210,
            top: this.props.sideBarOpen ? 200 : 275,
            marginBottom: 90, //90
            position: "absolute",
            textAlign: "left",
            userSelect: "none", // don't let user highlight text
            width: 705,
            backgroundColor: "rgba(9, 44, 116, .38)",
            borderRadius: 25,
            padding: 22,
        };

        const sourceText = (
            <div style={sourceTextStyle}>
                H-LiST was developed by the Center for Humanitarian Health at Johns Hopkins University, in collaboration
                with the Lives Saved Tool (LiST) team and UNHCR. It is supported by the Bill & Melinda Gates Foundation.
            </div>
        );

        return (
            <div style={{ position: "relative" }}>
                {bannerImg}
                {window.innerWidth > GBConst.smScreen
                    ? !this.props.sideBarOpen
                        ? welcomeText
                        : window.innerWidth >= GBConst.mdScreen
                        ? welcomeText
                        : null
                    : null}
                {window.innerWidth >= GBConst.lgScreen ? sourceText : null}
            </div>
        );
    }
}

export default HLIntroBanner;
